import Vue from 'vue'
import router from './router'
import App from './App.vue'
import axios from 'axios'
import Mint from 'mint-ui'
import config from './config'
import init from '@ivy/fts'
import store from './store/store'
import { AxiosInstance } from "axios"
import { closeAll } from "@ivy/fts/showDiv"
import VueLazyload from 'vue-lazyload'
import Cookies from "js-cookie"
import Own from "./components/own.vue"
let InfiniteScroll = Mint.InfiniteScroll
Vue.use(InfiniteScroll)
Vue.component('Own', Own)
declare module "vue/types/vue" {
  interface Vue {
    $store: any,
    Cookies: any
  }
}
init({ Vue, router, axios, config, Mint })
Vue.use(VueLazyload, {
  preLoad: 1,
  error: require('../static/ivy-logo.png'),
  loading: require('../static/loading.gif'),
  attempt: 3
})
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.prototype.Cookies = Cookies
Vue.config.productionTip = false
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
  closeAll()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
